import { React } from '@gravityforms/libraries';

const { createContext, useContext, useState } = React;

const StoreContext = createContext( null );

/**
 * @function useStoreContext
 * @description Uses the store context to access the store.
 *
 * @since 4.0.1
 *
 * @param {Function} selector The selector function for the store.
 *
 * @return {*} The store property if selector is provided, or the entire store if no selector is provided.
 */
export const useStoreContext = ( selector ) => {
	const store = useContext( StoreContext );
	if ( ! store ) {
		throw new Error( 'Missing StoreProvider.' );
	}
	return store( selector );
};

/**
 * @function StoreProvider
 * @description The store provider component.
 *
 * @since 4.0.1
 *
 * @param {object}      props              The props for the component.
 * @param {JSX.Element} props.children     The children to render.
 * @param {object}      props.initialState The initial state.
 * @param {Function}    props.createStore  The store creation function.
 *
 * @return {Function} The store provider.
 */
export const StoreProvider = ( { children, initialState, createStore } ) => {
	const [ store ] = useState( () => {
		return createStore( initialState );
	} );
	return (
		<StoreContext.Provider value={ store }>
			{ children }
		</StoreContext.Provider>
	);
};
